import { useMemo } from 'react';

import { DateTime } from 'luxon';
import { Card, Divider, Skeleton, Stack, Text, Title } from 'ui';

import { useShowEntryByProviderId } from '../../../../hooks/queries/Ledger/owner';
import { LinkedEntryCard } from './LinkedEntryCard';

type Props = {
  entryId: string;
};
const EntryList = ({ entryId }: Props) => {
  const { data: entryData, isLoading } = useShowEntryByProviderId(entryId);

  const title = useMemo(() => {
    return entryData?.title ? `${entryData?.title} Purchase` : 'Purchase';
  }, [entryData?.title]);

  return (
    <Stack>
      <Title order={2} visibleFrom={'md'}>
        {title}
      </Title>
      <Card radius={8} p={0} bd="1px solid gray.1">
        <Stack gap={0}>
          <Stack p={'md'}>
            {entryData?.entries?.map((entry) => (
              <LinkedEntryCard key={entry.uuid} entry={entry} />
            ))}
          </Stack>
          <Divider />
          <Stack p="md">
            <Stack gap="xs">
              <Text fz={14} fw={600}>
                Transaction Date
              </Text>
              <Text fz={14} c="gray">
                <Skeleton visible={isLoading}>
                  {entryData?.timestamp
                    ? DateTime.fromISO(entryData?.timestamp).toFormat('MM/dd/yy')
                    : ''}
                </Skeleton>
              </Text>
            </Stack>
            <Stack gap="xs">
              <Text fz={14} fw={600}>
                Completed Date
              </Text>
              <Text fz={14} c="gray">
                <Skeleton visible={isLoading}>
                  {entryData?.status === 'complete' && entryData?.completed_at
                    ? DateTime.fromISO(entryData?.completed_at).toFormat('MM/dd/yy')
                    : 'Pending'}
                </Skeleton>
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};

export { EntryList };
